import {
  FilterType,
  buildPerformanceReviewsDataTableFilter,
  usePerformanceReviewsDataTable,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import AccessFilterSelector from './AccessFilterSelector'

const revieweeFilter = (source: ReturnType<typeof usePerformanceReviewsDataTable>) =>
  buildPerformanceReviewsDataTableFilter(source, {
    title: i18n.t('performance_process.reviews.datatable.reviewee'),
    path: 'revieweeIds',
    type: FilterType.Entity,
    categories: [
      {
        kind: 'Entity',
        operation: 'in',
        component: () => <AccessFilterSelector />,
        nameAttribute: 'fullName',
      },
    ],
    identifier: 'revieweeIds',
  })

export default revieweeFilter
